import { Slider } from 'antd'
import { SliderRangeProps } from 'antd/es/slider'
import { useEffect, useState } from 'react'

type BaseSliderProps = Omit<SliderRangeProps, 'range' | 'onChange'>

interface SliderRangeCustom extends BaseSliderProps {
  onChangeGeneric: (value: number[]) => void
  sliderValue: number[]
}

const SliderRange = ({
  sliderValue,
  onChangeGeneric,
  tooltip,
  ...sliderProps
}: SliderRangeCustom) => {
  const [value, setValue] = useState<number[]>(sliderValue ?? [])

  useEffect(() => {
    setValue(sliderValue ?? [])
  }, [sliderValue])

  const handleChange = (value: number[]) => {
    setValue(value)
    onChangeGeneric?.(value)
  }

  return (
    <Slider
      range={true}
      {...sliderProps}
      value={value}
      onChange={handleChange}
      tooltip={tooltip}
    />
  )
}

export default SliderRange
